import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class TabSelect extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {}

    this.config = { 
      types : [
        {
          title : 'default',
          isDefault : true
        },
        'inverse'
      ],
      modifiers : [],
      states : []
    }

    this.state = {
      currentIndex : 0,
      currentData : {}
    }

    this.handleTabClick = this.handleTabClick.bind(this)
  }

  renderTabAction(item, index) {
    if(item.href) {
      return <a className="mdn-TabSelect-anchor" target={item.target} href={item.href} data-tabselect-index={index}>{item.title}</a>
    } else if (item.routeLink) {
      return item.routeLink
    } else {
      return <span className="mdn-TabSelect-anchor" onClick={()=>{this.handleTabClick(index)}} data-tabselect-index={index}>{item.title}</span>
    }
  }

  renderTabHeader(data) {
    return data.map((item, index) => {
      let className = ''
      
      if (this.state.currentIndex === index) {
        className = "mdn-TabSelect-active"
      }

      return <li key={index} className={"mdn-TabSelect-item " + className}>
        {this.renderTabAction(item, index)}
     </li>
    })
  }
  
  renderTabContent(data){
    return <div className="mdn-TabSelect-panel mdn-TabSelect-active">
      {this.state.currentData.content}
    </div>
  }

  handleTabClick(index) {
    this.setState({ currentIndex: index })
  }

  componentDidMount() {
    const data = this.props.data || this.props.dataTabSelect
    if(!data || !data[0]) throw new Error(`You must specify a "data <array of objects>" to TabSelect component.`);
    
    for(let i = 0, lgt = data.length; i < lgt; i++){
      if(data[i].isActive === true) {
        this.setState({currentIndex : i});
        break;
      }
    }

  }
  
  render() {
    const { inverse, data, dataTabSelect, ...rest } = this.props      
    let mainData = data || dataTabSelect;
    return <div {...rest} className={resolveProps(this.props, this.config, "TabSelect")}>
      <ul className="mdn-TabSelect-list">
        { this.renderTabHeader(mainData) }
      </ul>
      <div className="mdn-TabSelect-content">
        <div className="mdn-TabSelect-panel mdn-TabSelect-active">
          { (mainData)[this.state.currentIndex].content }
        </div>
      </div>
    </div>
  }
}
 
TabSelect.propTypes = {
  dataTabSelect: PropTypes.array
}